import { localStorage } from '@fiverr-private/futile';
import { STORAGE_PREFIX } from './constants';

export const isSeen = (tooltipKey) => {
    if (!tooltipKey) {return false;}

    return get(tooltipKey) === 'true';
};

export const setSeen = (tooltipKey) => {
    if (!tooltipKey) {return;}

    set(tooltipKey, 'true');
};

const get = (tooltipKey) => localStorage.get(storageKey(tooltipKey));

const set = (tooltipKey, value) => {
    localStorage.set(storageKey(tooltipKey), value);
};

const storageKey = (tooltipKey) => `${STORAGE_PREFIX}.${tooltipKey}`;
